export default "__VITE_ASSET__D7S6twMY__"